import {
  BriefcaseBusiness,
  Code2,
  Palette,
  Database,
  UsersRound,
  Mail,
  MapPin,
  ListChecks,
  MessageCircle,
  Home,
  Workflow,
  Globe,
  UserRound,
  PhoneCall,
  ShieldCheck,
  ServerCog,
  Terminal,
} from "lucide-react";
import lms from "src/assets/images/projects/lms.png";
import dorsaCloudImage from "src/assets/images/projects/dorsa-cloud.png";
import aminAfzarJavan from "src/assets/images/projects/amaj.png";
import airsheet from "src/assets/images/projects/airsheet.png";
import nikahang from "src/assets/images/projects/nikahang.png";
import sgi from "src/assets/images/projects/sgi.png";
import apadana from "src/assets/images/projects/apadana.png";

const birthDate = {
  year: 2002,
  month: 10,
  day: 12,
};

export const calculateAge = (
  birth: { year: number; month: number; day: number },
  today = new Date(),
) => {
  let age = today.getFullYear() - birth.year;

  const currentMonth = today.getMonth() + 1;
  const currentDay = today.getDate();

  const birthdayPassed =
    currentMonth > birth.month ||
    (currentMonth === birth.month && currentDay >= birth.day);

  if (!birthdayPassed) {
    age -= 1;
  }

  return age;
};

export const currentAge = calculateAge(birthDate);

export const barItems = [
  { title: "barItems.home", path: "/", icon: Home },
  { title: "barItems.about", path: "/about", icon: UserRound },
  { title: "barItems.services", path: "/services", icon: ListChecks },
  { title: "barItems.portfolio", path: "/portfolio", icon: BriefcaseBusiness },
  { title: "barItems.contact", path: "/contact", icon: MessageCircle },
];

export const aboutMe = "aboutMe.text";

export const details = [
  { title: "details.birthday", value: "details.birthday.value" },
  { title: "details.age", value: currentAge },
  { title: "details.website", value: "details.website.value" },
  { title: "details.email", value: "details.email.value" },
  { title: "details.degree", value: "details.degree.value" },
  { title: "details.phone", value: "details.phone.value" },
  { title: "details.location", value: "details.location.value" },
  { title: "details.freelance", value: "details.freelance.value" },
];

export const skills = [
  { title: "Vue JS, Quasar, Tailwind CSS", value: 90 },
  { title: "React JS, Next JS, Joy UI", value: 85 },
  { title: "TypeScript, JavaScript", value: 85 },
  { title: "UI/UX Implementation", value: 80 },
  { title: "Node JS, Express, Nest JS", value: 75 },
  { title: "GraphQL, REST API", value: 70 },
  { title: "MongoDB, Mongoose, Redis", value: 70 },
  { title: "Docker, Linux, Deployment", value: 70 },
  { title: "No-Code Platform Development", value: 85 },
  { title: "Project Management", value: 70 },
];

export const educations = [
  {
    title: "educations.computerScience",
    date: "educations.computerScience.date",
    text: "educations.computerScience.text",
  },
  {
    title: "educations.webDesign",
    date: "educations.webDesign.date",
    text: "educations.webDesign.text",
  },
  {
    title: "educations.backendDevelopment",
    date: "educations.backendDevelopment.date",
    text: "educations.backendDevelopment.text",
  },
  {
    title: "educations.frontendDevelopment",
    date: "educations.frontendDevelopment.date",
    text: "educations.frontendDevelopment.text",
  },
];

export const experience = [
  {
    title: "experience.emad",
    date: "experience.emad.date",
    text: "experience.emad.text",
  },
  {
    title: "experience.vadud.first",
    date: "experience.vadud.first.date",
    list: [
      "experience.vadud.first.list.1",
      "experience.vadud.first.list.2",
      "experience.vadud.first.list.3",
      "experience.vadud.first.list.4",
    ],
  },
  {
    title: "experience.amaj",
    date: "experience.amaj.date",
    list: [
      "experience.amaj.list.1",
      "experience.amaj.list.2",
      "experience.amaj.list.3",
      "experience.amaj.list.4",
      "experience.amaj.list.5",
    ],
  },
  {
    title: "experience.nextera",
    date: "experience.nextera.date",
    list: [
      "experience.nextera.list.1",
      "experience.nextera.list.2",
      "experience.nextera.list.3",
    ],
  },
  {
    title: "experience.vadud.current",
    date: "experience.vadud.current.date",
    list: [
      "experience.vadud.current.list.1",
      "experience.vadud.current.list.2",
      "experience.vadud.current.list.3",
      "experience.vadud.current.list.4",
      "experience.vadud.current.list.5",
      "experience.vadud.current.list.6",
      "experience.vadud.current.list.7",
    ],
  },
];

export const services = [
  {
    icon: Code2,
    title: "services.frontendDevelopment",
    description: "services.frontendDevelopment.description",
  },
  {
    icon: Database,
    title: "services.noCodeDevelopment",
    description: "services.noCodeDevelopment.description",
  },
  {
    icon: ServerCog,
    title: "services.backendDevelopment",
    description: "services.backendDevelopment.description",
  },
  {
    icon: Palette,
    title: "services.uiUxImplementation",
    description: "services.uiUxImplementation.description",
  },
  {
    icon: Workflow,
    title: "services.integrationDevelopment",
    description: "services.integrationDevelopment.description",
  },
  {
    icon: Terminal,
    title: "services.deploymentSupport",
    description: "services.deploymentSupport.description",
  },
  {
    icon: ShieldCheck,
    title: "services.securityReview",
    description: "services.securityReview.description",
  },
  {
    icon: UsersRound,
    title: "services.projectManagement",
    description: "services.projectManagement.description",
  },
];

export const projects = [
  {
    image: lms,
    title: "projects.lms",
    link: "https://lms-dev.posechecker.com/",
  },
  {
    image: dorsaCloudImage,
    title: "projects.dorsaCloud",
    link: "https://my.dorsa.cloud/",
  },
  {
    image: aminAfzarJavan,
    title: "projects.amaj",
    link: "https://www.aminafzar.com/",
  },
  {
    image: airsheet,
    title: "projects.airsheet",
    link: "https://www.airsheet.ir/",
  },
  {
    image: nikahang,
    title: "projects.nikahang",
  },
  {
    image: sgi,
    title: "projects.sgi",
  },
  {
    image: apadana,
    title: "projects.apadana",
    link: "https://panel.apadanacloud.com/",
  },
];

export const contacts = [
  {
    icon: PhoneCall,
    title: "contact.phone",
    text: "contact.phone.value",
    link: "tel: +98 9120075062",
  },
  {
    icon: MapPin,
    title: "contact.office",
    text: "contact.office.value",
    link: "https://goo.gl/maps/afqZKx2bNWT1bz84A",
  },
  {
    icon: Mail,
    title: "contact.email",
    text: "contact.email.value",
    link: "mailto: sh.abolfazl.ir@gmail.com",
  },
  {
    icon: Globe,
    title: "contact.website",
    text: "contact.website.value",
    link: "http://abolfazl-shafaghi.com",
  },
];
